export const color = {
  primary: {
    white: '#FFFFFF',
    black: '#2F2F2F',
    blue: '#407BFF',
  },
  secondary: {
    white: '#ECF2FF',
    tomato: '#EF5050',
    azure: '#9EBBFF',
    orange: '#FF9D43',
    gray: '#D7E3FF',
  },
};
